<template>
    <div class="other-tenant-item-content other-tenant-middle-table">
        <span class="other-tenant-title middle-table-title">中间表数据处理情况</span>
        <ul>
            <li class="middle-table-item" v-for="(item,index) in middleTableList" :key="index">
                <div class="middle-table-item-left">
                    <img class="middle-table-item-img" :src="item.labelImg" width="18" height="18" alt="">
                    <div>
                        <div class="middle-table-item-title">{{item.labelTitle}}</div>
                    </div>
                </div>
                <div class="middle-table-item-right">
                    <div class="middle-table-item-data">
                        <span class="middle-table-item-count">{{formatCount(middleTableData[item.count])}}&ensp;(ID) </span>
                        <img v-if="judgePositive(middleTableData[item.percentage])" src="../../../../../assets/images/icon_shangshen_green.svg" width="8" height="8" alt="">
                        <img v-else src="../../../../../assets/images/icon_xiajiang_red.svg" width="8" height="8" alt="">
                        <span :class="[judgePositive(middleTableData[item.percentage])?'middle-success':'middle-fail','middle-table-item-percentage']"
                        > {{formatPercentage(middleTableData[item.percentage])}}</span>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import { MIDDLE_TABLE_LIST } from '../otherTenantConst';
import { formatNegative } from '../../../../../utils/common';
export default {
    data() {
        return {
            middleTableList: MIDDLE_TABLE_LIST,
            middleTableData: {}
        };
    },
    methods: {
        formatCount(num) {
            const count = num || 0;
            return count.toLocaleString();
        },
        formatPercentage(num) {
            return formatNegative(num);
        },
        judgePositive(num) {
            return (!num) || (num && num.indexOf('-') === -1);
        },
        dataProcess(data) {
            this.middleTableData = { ...data };
        }
    }
};
</script>
<style lang="less">
.other-tenant-middle-table{
    height: 296px;
    .middle-table-title{
        margin-bottom: 30px !important;
    }
    .middle-table-item{
        // height: 44px;
        display: flex;
        margin-bottom: 32px;
        .middle-success{
            color: #00c66b;
        }
        .middle-fail{
            color: #ff3c3c;
        }
    }
    .middle-table-item-left{
        flex: 1;
        display: flex;
    }
    .middle-table-item-img{
        margin-right: 6px;
    }
    .middle-table-item-title{
        font-family: 'PingFangSC-Regular', sans-serif;
        font-size: 14px;
        color: #666666;
        line-height: 18px;
        font-weight: 400;
    }
    .middle-table-item-count{
        font-family: 'PingFangSC-Medium', sans-serif;
        font-size: 14px;
        color: #333333;
        line-height: 18px;
        font-weight: 600;
    }
    .middle-table-item-percentage{
        font-family: 'PingFangSC-Semibold', sans-serif;
        font-size: 10px;
        line-height: 10px;
        font-weight: 600;
    }
}
</style>